export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.075 } },
};

// For compact elements (headings, single cards): reveal once 15% is on screen.
export const viewport = { once: true, amount: 0.15 };

// For tall containers (grids / lists that can exceed the viewport height on
// mobile): reveal as soon as ANY part is on screen. A fractional threshold
// on a container taller than the screen can never be met, which left whole
// listings invisible on phones.
export const containerViewport = { once: true, amount: "some" };
